import { render, staticRenderFns } from "./NonStandartEditor.vue?vue&type=template&id=60a5750c"
import script from "./NonStandartEditor.vue?vue&type=script&lang=js"
export * from "./NonStandartEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports